<template>
  <div class="option" :class="{ disabled: isDisabled, 'modal-mode': isModalMode }" @click="onClick">
    <div class="option__icon">
      <img :src="iconUrl" alt="" />
    </div>
    <div class="option__text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerOptionButton',
  props: {
    id: {
      type: [Number, String],
      default: 0,
    },
    iconUrl: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isModalMode: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.isDisabled) {
        return;
      }
      this.$emit('click-option', this.id);
    },
  },
};
</script>

<style scoped lang="scss">
.option {
  font-size: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  &__icon {
    height: 24px;
    width: 24px;

    & > img {
      height: 24px;
      width: 24px;
    }
  }

  &__text {
    font-family: Avenir-Demi, sans-serif;
    font-size: 0.625em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0.3px;
    text-align: center;
    color: #fff;
    white-space: nowrap;
  }

  &.disabled {
    cursor: default;
    opacity: 0.5;
  }

  &.modal-mode {
    & > div.option__text {
      margin-top: 0.6em;
      opacity: 0.8;
      font-family: Avenir-Demi-Medium, sans-serif;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.67;
      letter-spacing: 0.29px;
      text-align: left;
      color: #132839;
    }

    & > div.option__icon {
      height: 32px;
      width: 32px;

      & > img {
        height: 32px;
        width: 32px;
      }
    }

    @media screen and (max-width: 430px) {
      & > div.option__text {
        font-size: 0.8em;
      }

      & > div.option__icon {
        height: 24px;
        width: 24px;

        & > img {
          height: 24px;
          width: 24px;
        }
      }
    }
  }
}
</style>
